(ns ycweb.app.website.dlp.widgets.header
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(defn add-styles [custom-logo-size]
  (str
    "<style type='text/css'>
        @media screen and (min-width: 47.5em) {
            .header-banner__logo--custom {
                max-width: " (int (* custom-logo-size 0.5)) "px;
            }
        }
        @media screen and (min-width: 62.5em) {
            .header-banner__logo--custom {
                max-width: " (int (* custom-logo-size 0.6)) "px;
            }
        }
        @media screen and (min-width: 90em) {
            .header-banner__logo--custom {
                max-width: " (int (* custom-logo-size 0.75)) "px;
            }
        }
        @media screen and (min-width: 91.25em) {
            .header-banner__logo--custom {
                max-width: " custom-logo-size "px;
            }
        }
    </style>"))

(defn breadcrumbs [app-atom cat-path breadcrumb-type]
  [:nav.dlp-breadcrumbs
   [:ul.group
    {:class (u/bem :breadcrumbs [:centered])}
    (when (= breadcrumb-type "c")
      [:li
       {:class (u/bem :breadcrumbs__item [:always-show])}
       [:a.breadcrumb__link
        (urlstate/href-props app-atom "products")
        [:span.unclip-text--s.clip-text--m
         [:i {:class (u/bem :icon [:arrow-left :is-dark :small :inline])}]
         "Back to "]
        "Products"]])
    (map
      (fn [{:keys [cat-url] :as category}]
        (cond
          (= (:name category) (:name (last cat-path)))
          [:li.breadcrumbs__item.last-child
           [:span.breadcrumbs__current-text
            (:name category)]]

          :else
          [:li
           {:class (u/bem :breadcrumbs__item [:always-show])}
           [:a.breadcrumb__link
            (urlstate/href-props
              app-atom
              cat-url)
            (:name category)]]))
      cat-path)]])

(rum/defc header < rum/reactive [app-atom _ {:keys [properties]}]
  (let [{:header/keys
         [hide-header-banner responsive-banner-public-id breadcrumb-type background-colour
          logo-public-id logo-custom-size title subtitle
          sub-title-placement copy cat-path show-content?]} properties

        breadcrumbs? (not (= breadcrumb-type "n"))]

    (when show-content?
      [:<>
       (when-not hide-header-banner
         (list
           [:div
            {:class
             (u/bem
               :header-banner
               [(when-not responsive-banner-public-id :no-image) (when breadcrumbs? :flush)]
               (if background-colour
                 (str "u-bg-" (:banner-background-colour/colour-name background-colour))
                 "u-bg-oil"))}

            [:div.header-banner__text-wrapper
             [:div.header-banner__text
              {:class
               (if (:banner-background-colour/text-dark background-colour)
                 "u-text-oil"
                 "u-text-white")}

              (cond
                logo-public-id
                (web-common/lazy-image app-atom
                  logo-public-id
                  {:class (u/bem "header-banner__logo" [(when logo-custom-size :custom)])}
                  {:q "auto"
                   :alt (str title " logo")})

                (and title (not logo-public-id))
                [:h1.header-banner__title
                 (when (and subtitle (= sub-title-placement "above"))
                   [:span.header-banner__pretitle
                    subtitle
                    [:span.u-hidden-from-view " – "]])
                 title
                 (when (and subtitle (= sub-title-placement "below"))
                   [:span.header-banner__subtitle
                    [:span.u-hidden-from-view " – "]
                    subtitle])])]]

            (when responsive-banner-public-id
              [:div.header-banner__image-wrapper
               (web-common/lazy-image app-atom
                 responsive-banner-public-id
                 {:class ["header-banner__image"]}
                 {:w 960
                  :mw 490
                  :q "auto"
                  :alt (str "Banner image of " title)})])]

           (when logo-custom-size
             [:div
              {:dangerouslySetInnerHTML
               {:__html (add-styles (u/parseInt logo-custom-size))}}])

           (when breadcrumbs?
             (breadcrumbs app-atom cat-path breadcrumb-type))))

       (when (or title copy subtitle)
         [:div.yc-section
          [:div.yc-intro-text
           (cond
             hide-header-banner
             (when (or title subtitle)
               (cond
                 (and title subtitle)
                 (headings/heading
                   title
                   {:type :h1
                    :dangerouslySetInnerHTML? true
                    :size
                    (if (and title logo-public-id) :medium :large)
                    :center true
                    :subtext subtitle})

                 title
                 (headings/heading
                   title
                   {:type :h1
                    :dangerouslySetInnerHTML? true
                    :size :large
                    :center true})))

             :else
             (when (and (or title subtitle) logo-public-id)
               (let [heading-default (or subtitle title)]
                 (headings/heading
                   (if (and title subtitle)
                     (str "<span class='hidden-from-view'>" title " - </span>" heading-default)
                     heading-default)
                   {:dangerouslySetInnerHTML? true
                    :center true
                    :size :medium}))))

           (when copy
             [:div
              {:dangerouslySetInnerHTML
               {:__html copy}}])]])])))
